import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  lock: { display: 'flex', margin: 'auto', marginTop: '25px', marginBottom: '25px' },
  parentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '8px',
    color: '#1C2541',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '32px',
    fontWeight: '700',
  },
  subtitle: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '40px',
    fontSize: '16px',
  },
  button: {
    marginTop: '24px',
    color: '#31525E',
    fontSize: '14px',
    backgroundColor: '#5ED1F0',
    borderRadius: '100px',
    maxWidth: '600px',
    '&:hover': {
      backgroundColor: '#54bcd8',
    },
  },
}));
